import PropTypes from 'prop-types';
//import material
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
//import style
import { DialogTitle, DialogContent, DialogActions } from './productosComponents';
import { styles } from './productosComponents';
import { RiDeleteBinLine } from 'react-icons/ri';
import { BiListPlus } from 'react-icons/bi';
import { useEffect, useState } from 'react';
import { IconButton } from '@mui/material';

function ModalProductosRechazados({ modal, toggleModal, rechazados, setRechazados }) {
  const classes = styles;
  const [detalle, setDetalle] = useState('');

  function addToList() {
    setRechazados(prev => [...prev, detalle]);
  }

  useEffect(() => {
    setDetalle('');
  }, [JSON.stringify(rechazados)]);

  return (
    <div>
      <Dialog onClose={toggleModal} aria-labelledby='customized-dialog-title' open={modal} maxWidth='lg'>
        <form onSubmit={toggleModal} className={classes.form}>
          <DialogTitle id='customized-dialog-title' onClose={toggleModal}>
            Agregar productos rechazados
          </DialogTitle>

          <DialogContent dividers>
            <TextField
              variant="standard"
              fullWidth
              id='detalle'
              name='detalle'
              label='Descripcion producto rechazado'
              value={detalle}
              onChange={e => setDetalle(e.target.value)} />
            <IconButton
              color='primary'
              aria-label='upload picture'
              component='span'
              onClick={addToList}
              size="large">
              <BiListPlus />
            </IconButton>
            <ul>
              {rechazados.map((detail, index) => {
                return (
                  <li key={index}>
                    {detail} <RiDeleteBinLine onClick={() => setRechazados(prev => prev.filter(value => value !== detail))} />
                  </li>
                );
              })}
            </ul>
          </DialogContent>
          <DialogActions>
            <Button color='primary' variant='contained' type='submit'>
              Finalizar
            </Button>
            <Button color='primary' variant='contained' type='cancel'>
              Cancelar
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}

ModalProductosRechazados.propTypes = {
  modal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  rechazados: PropTypes.array,
  setRechazados: PropTypes.func,
};

export default ModalProductosRechazados;
